import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  selectUsers,
  selectUsersError,
  selectUsersLoading,
} from "../store/reducers/users/users.selectors";
import { useEffect } from "react";
import { getUsersThunk } from "../store/reducers/users/users.thunks";
import Loader from "../components/UI/Loader";
import Alert from "../components/UI/Alert";
import UsersTable from "../components/users/UsersTable";
import UsersHeader from "../components/users/UsersHeader";
import { UsersPaginationProvider } from "../context/users/UsersPagination";
import Pagination from "../components/UI/Pagination";
import {
  clearUsersError,
  setPage,
} from "../store/reducers/users/users.reducer";
import UserViewModal from "../components/users/UserViewModal";
import ConfirmToggleModal from "../components/users/ConfirmToggleModal";
import UserEditModal from "../components/users/Usereditmodal";

const UsersPage = () => {
  const dispatch = useDispatch();

  const users = useSelector(selectUsers);
  const loading = useSelector(selectUsersLoading);
  const error = useSelector(selectUsersError);

  const { page, next, previous, search, count, escuelaFilter, plantelFilter } =
    useSelector((state) => state.users);

  useEffect(() => {
    dispatch(
      getUsersThunk({
        page,
        search,
        escuela: escuelaFilter,
        plantel: plantelFilter,
      }),
    );
  }, [dispatch, page, search, escuelaFilter, plantelFilter]);

  return (
    <UsersPaginationProvider>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <UsersHeader />
          {error && (
            <Alert
              message={error}
              variant="error"
              onClose={() => dispatch(clearUsersError())}
            />
          )}
          {loading ? (
            <Loader center text="Cargando usuarios..." delay={2000} />
          ) : (
            <>
              {search && (
                <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                  <Icon icon="mdi:information-outline" width="18" />
                  <span className="text-sm">
                    {count > 0 ? (
                      <>
                        Se {count === 1 ? "encontró" : "encontraron"}{" "}
                        <strong className="text-primary">{count}</strong>{" "}
                        {count === 1 ? "resultado" : "resultados"} para "
                        {search}"
                      </>
                    ) : (
                      <>No se encontraron resultados para "{search}"</>
                    )}
                  </span>
                </div>
              )}

              <UsersTable users={users} search={search} />

              {(next || previous) && (
                <div className="mt-4">
                  <Pagination
                    page={page}
                    count={count}
                    pageSize={10}
                    onPageChange={(p) => dispatch(setPage(p))}
                  />
                </div>
              )}
            </>
          )}
        </div>
        <UserViewModal />
        <ConfirmToggleModal />
        <UserEditModal />
      </div>
    </UsersPaginationProvider>
  );
};

export default UsersPage;
